export default __webpack_public_path__ + "static/media/logo-small.bd4a83b8.svg";